// UI Component: Aurora Background Animation
import React from "react";

const AuroraBackground = ({
  className = "",
  children,
  showRadialGradient = true,
  ...props
}) => {
  // CSS class'larını birleştiren yardımcı fonksiyon
  const cn = (...classes) => classes.filter(Boolean).join(' ');

  return (
    <div
      className={cn(
        "aurora-background relative flex flex-col items-center justify-center bg-zinc-50 text-slate-950 transition-all duration-500",
        className
      )}
      style={{
        minHeight: '100vh',
        position: 'relative',
        overflow: 'hidden'
      }}
      {...props}
    >
      <div 
        className="aurora-overlay"
        style={{
          position: 'absolute',
          inset: '0',
          overflow: 'hidden',
          pointerEvents: 'none'
        }}
      >
        <div
          className="aurora-animation"
          style={{
            position: 'absolute',
            inset: '-10px',
            opacity: '0.3',
            willChange: 'transform',
            filter: 'blur(10px)',
            background: `
              repeating-linear-gradient(100deg, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.9) 7%, transparent 10%, transparent 12%, rgba(255,255,255,0.9) 16%),
              repeating-linear-gradient(100deg, rgba(240,253,250,0.4) 10%, rgba(248,250,252,0.3) 15%, rgba(241,245,249,0.3) 20%, rgba(243,244,246,0.2) 25%, rgba(240,253,250,0.4) 30%)
            `,
            backgroundSize: '300% 200%',
            backgroundPosition: '50% 50%',
            animation: 'aurora 60s linear infinite',
            ...(showRadialGradient && {
              maskImage: 'radial-gradient(ellipse at 100% 0%, black 10%, transparent 70%)',
              WebkitMaskImage: 'radial-gradient(ellipse at 100% 0%, black 10%, transparent 70%)'
            })
          }}
        />
        <div
          className="aurora-animation-after"
          style={{
            position: 'absolute',
            inset: '0',
            background: `
              repeating-linear-gradient(100deg, rgba(255,255,255,0.7) 0%, rgba(255,255,255,0.7) 7%, transparent 10%, transparent 12%, rgba(255,255,255,0.7) 16%),
              repeating-linear-gradient(100deg, rgba(240,253,250,0.2) 10%, rgba(248,250,252,0.15) 15%, rgba(241,245,249,0.15) 20%, rgba(243,244,246,0.1) 25%, rgba(240,253,250,0.2) 30%)
            `,
            backgroundSize: '200% 100%',
            backgroundAttachment: 'fixed',
            animation: 'aurora 60s linear infinite',
            mixBlendMode: 'difference',
            pointerEvents: 'none'
          }}
        />
      </div>
      {children}
    </div>
  );
};

export default AuroraBackground; 